import React, { useMemo } from 'react';
import { Box } from '@mui/joy';
import DashboardReportPrintCover from './DashboardReportPrintCover';
import { DashboardPrintRenderContext } from './DashboardPrintRenderContext';
import { DASHBOARD_PRINT_CRITICAL_CSS } from './dashboardPrintCriticalStyles';
import { flattenReportPages } from './flattenReportPages';

const DashboardReportPrintView = ({ report, title, printedAtLabel, filterModel }) => {
    const pages = useMemo(() => flattenReportPages(report), [report]);

    if (pages.length === 0) {
        return null;
    }

    return (
        <DashboardPrintRenderContext.Provider value={true}>
            <style>{DASHBOARD_PRINT_CRITICAL_CSS}</style>
            <Box className="mtska-dashboard-print-document">
            <DashboardReportPrintCover
                title={title}
                printedAtLabel={printedAtLabel}
                filterModel={filterModel}
            />

            {pages.map((page, index) => (
                <Box key={page.key} className="mtska-dashboard-print-page">
                    <Box className="mtska-dashboard-print-page-header">
                        {page.sectionTitle ? <h2>{page.sectionTitle}</h2> : null}
                        {page.pageTitle ? <h3>{page.pageTitle}</h3> : null}
                        <span className="mtska-dashboard-print-page-number">
                            {index + 1} / {pages.length}
                        </span>
                    </Box>
                    <Box className="mtska-dashboard-print-page-content">{page.component}</Box>
                </Box>
            ))}
            </Box>
        </DashboardPrintRenderContext.Provider>
    );
};

export default DashboardReportPrintView;
